import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES, AppRole } from '@core/constants';
import { AuthService } from '@core/services/auth.service';

/**
 * Allows navigation only when the user's `permisos` includes the given role.
 * On failure, redirects to the unauthorized view as a fallback.
 */
export const rolesGuard = (roles: readonly AppRole[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.hasAnyRole(roles)) return true;
    return router.createUrlTree([APP_ROUTES.AUTH.UNAUTHORIZED.go()]);
  };
};
